module.exports = __webpack_public_path__ + "img/5.8eb8e65d.jpg";